export default {
    methods: {
        createVuexSubscription(name, func) {
            return this.$store.subscribe((mutation, state) => {
                if (mutation.type === name) {
                    func.call(null, mutation.payload, state);
                }
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/subscription.js